





























































































































































































































































































import uploader from "../../common/components/uploader.vue";
import { WorkRecordServiceProxy } from "@/service-proxies/app-v2/work-record.service-proxies";
import { CustomerServiceProxy } from "@/service-proxies/app-v2/client.service-proxies";
import { MachineServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { isCellphoneNo } from "@/utils/validate";
import { DictBizServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const workRecordService = new WorkRecordServiceProxy();
const customerService = new CustomerServiceProxy();
const machineService = new MachineServiceProxy();
const dictBizService = new DictBizServiceProxy();

let timeout;
let currentValue;
let currentMachineCodeValue;
let currentMachineNameValue;

function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    customerService.getCustomers(value, '').then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          let address = '';
          if (r["provinceName"]) {
            if (r["provinceName"] === r["cityName"]) {
              address =  r["provinceName"] +`-`+r["address"];
            }else{
              address = r["provinceName"] +`-`+r["cityName"]+`-`+r["address"];
            }
          } 
          data.push({
            value: r["id"],
            text: r["name"],
            address: address,
          });
        });
        callback(data);
      }
    });
  }

  timeout = setTimeout(getCustomers, 120);
}

function fetchMachineCodes(value, customerId, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentMachineCodeValue = value;

  function getWorkstations() {
    machineService
      .getMachineSelectList(customerId, undefined, value)
      .then((d) => {
        if (currentMachineCodeValue === value) {
          const result = d;
          const data = [];
          result.forEach((r) => {
            data.push({
              value: r["id"],
              text: r["serialNo"],
              name: r["name"] + "(" + r["serialNo"] + ")",
            });
          });
          callback(data);
        }
      });
  }

  timeout = setTimeout(getWorkstations, 120);
}

function fetchMachineNames(value, customerId, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentMachineNameValue = value;

  function getWorkstations() {
    machineService
      .getMachineSelectList(customerId, value, undefined)
      .then((d) => {
        if (currentMachineNameValue === value) {
          const result = d;
          const data = [];
          result.forEach((r) => {
            data.push({
              value: r["id"],
              text: r["serialNo"],
              name: r["name"] + "(" + r["serialNo"] + ")",
            });
          });
          callback(data);
        }
      });
  }

  timeout = setTimeout(getWorkstations, 120);
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    workRecordId: {
      type: String,
      default: "",
    },
  },
  async created() {
    let res = await dictBizService.dictionary("job-type");
    this.jobTypeList = res.data;
    res = await dictBizService.dictionary("industry-type");
    this.industryTypeList = res.data;
  },
  watch: {
    workRecordId: {
      handler(val) {
        if (!val) {
          return;
        }
        if (!this.isEdit) {
          return;
        }
        workRecordService.getWorkRecordEditDetail(val).then((res) => {
          let form = res;
          form["questionDesc"] = form.questionDesc;
          form["componentDesc"] = form.componentDesc;
          this.form = { ...form };
          res.attachList.forEach((x) => {
            this.imageList.push({
              uid: x,
              type: "image",
              thumb: "",
              name: x,
              url: x,
            });
          });
          const video = eval(res.video) || [];
          video.forEach((x) => {
            this.videoList.push({
              uid: x.uid,
              type: x.type,
              thumb: x.thumb,
              name: x,
              url: x.url,
            });
          });
          if (this.form.componentDesc) {
            this.needComponent = true;
          }
        });
      },
      immediate: true,
    },
  },
  components: { uploader },
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value !== "") {
        if (!isCellphoneNo(value)) {
          const msg = this.$t("page_personal_phone_valid_tip");
          callback(new Error(msg.toString()));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const checkComponentDesc = (rule, value, callback) => {
      if (this.needComponent) {
        if (!value) {
          callback(
            new Error(this.$t("page_ops_work_record_component").toString())
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      jobTypeList: [],
      industryTypeList: [],
      needComponent: false,
      form: {
        customerId: undefined,
        customerAddress: "",
        currentMachine: undefined,
        questionDesc: "",
        componentDesc: "",
        jobType: undefined,
        industryType: undefined,
        contactInfo: "",
        email: "",
        wxAccount: "",
        contactUserName: "",
        attach: "",
        video: "",
        status: 1,
        isInvolvedMachine: 1,
        channelType: 4, // 4.工程师电话、3.客户电话、2.工程师小程序、1.客户小程序
      },
      data: [],
      machineInfo: [],
      rules: {
        questionDesc: [
          {
            required: true,
            message: this.$t("page_ops_work_record_problem_required"),
            trigger: "blur",
          },
        ],
        customerId: [
          {
            required: true,
            message: this.$t("page_ops_work_record_customer_required"),
            trigger: "change",
          },
        ],
        currentMachine: [
          {
            required: true,
            message: this.$t("page_ops_work_record_machine_required"),
            trigger: "change",
          },
        ],
        channelType: [
          {
            required: true,
            message: this.$t("please_select"),
            trigger: "change",
          }
        ],
        contactInfo: [{ validator: checkPhone, trigger: "change" }],
        componentDesc: [{ validator: checkComponentDesc, trigger: "change" }],
        email: [
          {
            type: "email",
            message: this.$t("page_user_management_correct_email_address"),
            trigger: "blur",
          },
        ],
      },
      loading: false,
      imageList: [],
      videoList: [],
    };
  },
  computed: {
    address() {
      if(this.form.customerAddress) {
        console.log(333, this.form.customerAddress)
        const {provinceName, cityName, address} = this.form.customerAddress;
        let showAddress = ''
        if(provinceName){
          if(provinceName ==cityName){
            showAddress =  `${provinceName}${address}`
          } else {
            showAddress = `${provinceName}${cityName}${address}`
          }
        } else {
          showAddress = address
        }
        return showAddress
      } else {
        return  '';
      }
    }
  },
  methods: {
    onInvolvedMachineChange(e) {
      const {value} = e.target;
      if(!value) {
        this.form.currentMachine = '';
      }
    },
    changeJobType(value) {
      this.form.jobType = value;
    },
    changeIndustryType(value) {
      this.form.industryType = value;
    },
    getImageList(e) {
      this.imageList = e;
    },
    getVideoList(e) {
      this.videoList = e;
    },
    handleCustomerSearch(value) {
      value = value === undefined ? "" : value;
      fetchCustomers(value, (data) => (this.data = data));
    },
    handleCustomerChange(value) {
      value = value === undefined ? "" : value;
      this.form.customerId = value;
      fetchCustomers(value, (data) => (this.data = data));
      this.machineInfo = [];
      this.form.currentMachine = undefined;
      // id 获取地址
      const customerItem = this.data.find((v) => v.value === value);
      this.form.customerAddress = { provinceName: '', cityName: '', address: customerItem.address };
    },
    handleMachineNameSearch(value) {
      value = value === undefined ? "" : value;
      fetchMachineNames(
        value,
        this.form.customerId,
        (data) => (this.machineInfo = data)
      );
    },
    handleMachineNameChange(value) {
      value = value === undefined ? "" : value;
      this.form.currentMachine = value;
      fetchMachineNames(
        value,
        this.form.customerId,
        (data) => (this.machineInfo = data)
      );
    },
    handleMachineSerialNoSearch(value) {
      value = value === undefined ? "" : value;
      fetchMachineCodes(
        value,
        this.form.customerId,
        (data) => (this.machineInfo = data)
      );
    },
    handleMachineSerialNoChange(value) {
      value = value === undefined ? "" : value;
      this.form.currentMachine = value;
      fetchMachineCodes(
        value,
        this.form.customerId,
        (data) => (this.machineInfo = data)
      );
    },
    save() {
      if (this.loading) {
        return;
      }
      if (this.imageList.length) {
        const data = this.imageList.map((v) => v.url);
        if (data.length > 1) {
          this.form.attach = data.join(",");
        } else {
          this.form.attach = data[0];
        }
      } else {
        this.form.attach = "";
      }
      if (this.videoList.length) {
        this.form.video = JSON.stringify(this.videoList);
      } else {
        this.form.video = "";
      }
      this.$refs.newWorkRecord.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.isEdit) {
            const params: any = {
              workRecordId: this.workRecordId,
              contactInfo: this.form.contactInfo,
              email: this.form.email,
              wxAccount: this.form.wxAccount,
              contactUserName: this.form.contactUserName,
              questionDesc: this.form.questionDesc,
              componentDesc: this.needComponent ? this.form.componentDesc : "",
              jobType: this.form.jobType,
              industryType: this.form.industryType,
              attach: this.form.attach,
              video: this.form.video,
            };
            workRecordService
              .update(params)
              .then((res) => {
                this.$refs.newWorkRecord.resetFields();
                this.machineInfo = [];
                this.data = [];
                this.form = {
                  customerId: undefined,
                  currentMachine: undefined,
                  questionDesc: "",
                  contactInfo: "",
                  email: "",
                  wxAccount: "",
                  componentDesc: "",
                  jobType: "",
                  industryType: "",
                  contactUserName: "",
                  attach: "",
                  video: "",
                  status: 1,
                };
                this.needComponent = false;
                this.imageList = [];
                this.videoList = [];
                this.loading = false;
                this.$message.success(this.$t("success"));
                this.$emit("ok");
              })
              .catch((_) => (this.loading = false));
            return;
          }

          const params: any = {
            contactInfo: this.form.contactInfo,
            email: this.form.email,
            wxAccount: this.form.wxAccount,
            contactUserName: this.form.contactUserName,
            customerId: this.form.customerId,
            questionDesc: this.form.questionDesc,
            componentDesc: this.needComponent ? this.form.componentDesc : "",
            jobType: this.form.jobType,
            industryType: this.form.industryType,
            workstationId: this.form.currentMachine,
            attach: this.form.attach,
            video: this.form.video,
            channelType: this.form.channelType,
            status: 1,
          };

          workRecordService
            .insert(params)
            .then((res) => {
              this.$refs.newWorkRecord.resetFields();
              this.machineInfo = [];
              this.data = [];
              this.form = {
                customerId: undefined,
                currentMachine: undefined,
                questionDesc: "",
                componentDesc: "",
                jobType: "",
                industryType: "",
                contactInfo: "",
                email: "",
                wxAccount: "",
                contactUserName: "",
                attach: "",
                video: "",
                status: 1,
              };
              this.needComponent = false;
              this.imageList = [];
              this.videoList = [];
              this.loading = false;
              this.$message.success(this.$t("success"));
              this.$emit("ok");
            })
            .catch((_) => (this.loading = false));
        }
      });
    },
    reset() {
      this.$refs.newWorkRecord.resetFields();
      this.form = {
        customerId: undefined,
        currentMachine: undefined,
        questionDesc: "",
        componentDesc: "",
        jobType: "",
        industryType: "",
        contactInfo: "",
        email: "",
        wxAccount: "",
        contactUserName: "",
        attach: "",
        video: "",
        status: 1,
      };
      this.needComponent = false;
      this.imageList = [];
      this.videoList = [];
      this.$emit("cancel");
    },
  },
};
